import { render, staticRenderFns } from "./DocDatenschutzerklarungView.vue?vue&type=template&id=13db2544&scoped=true"
import script from "./DocDatenschutzerklarungView.vue?vue&type=script&lang=js"
export * from "./DocDatenschutzerklarungView.vue?vue&type=script&lang=js"
import style0 from "./DocDatenschutzerklarungView.vue?vue&type=style&index=0&id=13db2544&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13db2544",
  null
  
)

export default component.exports